export default __webpack_public_path__ + "static/media/tutorial_preview_search2.879e26b6.png";